module.exports = __webpack_public_path__ + "img/smile-not-good.0bc41bfd.svg";